import LessThanIcon from './LessThanIcon'

export default LessThanIcon
